<template>
  <div>
    <div class="link">
      <!-- 客户id -->
      <div class="item">
        <div class="value"><el-input v-model="user_id" :placeholder="$t('message.userID')" clearable></el-input></div>
        <div class="search">
          <el-button type="primary" @click="linkUser">{{ $t('message.search') }}</el-button>
        </div>
      </div>
      <!-- 订单 -->
      <div class="item">
        <div class="value"><el-input v-model="order_sn" :placeholder="$t('message.orderNumber')" clearable></el-input>
        </div>
        <div class="search">
          <el-button type="primary" @click="linkOrder">{{ $t('message.search') }}</el-button>
        </div>
      </div>
      <!-- 配送单 -->
      <div class="item">
        <div class="value"><el-input v-model="porder_sn" :placeholder="$t('message.porder')" clearable></el-input>
        </div>
        <div class="search">
          <el-button type="primary" @click="linkPorder">{{ $t('message.search') }}</el-button>
        </div>
      </div>
      <!-- 售后单 -->
      <div class="item">
        <div class="value"><el-input v-model="after_sale_sn" :placeholder="$t('message.afterSalesOrderNumber')"
            clearable></el-input>
        </div>
        <div class="search">
          <el-button type="primary" @click="linkAfterSaler">{{ $t('message.search') }}</el-button>
        </div>
      </div>
      <!-- 赔款单 -->
      <div class="item">
        <div class="value"><el-input v-model="reparation_sn" :placeholder="$t('message.billOfIndemnity')"
            clearable></el-input>
        </div>
        <div class="search">
          <el-button type="primary" @click="reparationList">{{ $t('message.search') }}</el-button>
        </div>
      </div>
      <!-- 国际物流单号 -->
      <div class="item">
        <div class="value"><el-input v-model="express_no" :placeholder="$t('message.internationalLogisticsOrderNumber')"
            clearable></el-input>
        </div>
        <div class="search">
          <el-button type="primary" @click="linkExpress">{{ $t('message.search') }}</el-button>
        </div>
      </div>
      <!-- 检品单号 -->
      <div class="item">
        <div class="value"><el-input v-model="inspect_sn" :placeholder="$t('message.inspectionOrderNumber')"
            clearable></el-input>
        </div>
        <div class="search">
          <el-button type="primary" @click="linkInspect">{{ $t('message.search') }}</el-button>
        </div>
      </div>
      <!-- 交易号 -->
      <div class="item">
        <div class="value"><el-input v-model="purchase_no" :placeholder="$t('message.transactionNumber')"
            clearable></el-input>
        </div>
        <div class="search">
          <el-button type="primary" @click="linkPurchas">{{ $t('message.search') }}</el-button>
        </div>
      </div>
      <!--服务单号  -->
      <div class="item">
        <div class="value"><el-input v-model="service_sn" :placeholder="$t('message.serviceOrderNumber')"
            clearable></el-input>
        </div>
        <div class="search">
          <el-button type="primary" @click="linkService">{{ $t('message.search') }}</el-button>
        </div>
      </div>
    </div>
    <!-- 赔款 -->
    <claimIndemnity :indemnityList="list" ref="claimIndemnity" :reparation_sn="reparation_sn" :type="type" />
    <!-- 售中赔款 -->
    <inSaleClaimIndemnity ref="inSaleClaimIndemnity" :reparation_sn="reparation_sn" :type="type" />
    <!-- 赔款 -->
    <porderClaimIndemnity ref="porderClaimIndemnity" :reparation_sn="reparation_sn" :type="type" />
  </div>
</template>
<script>
import claimIndemnity from '../afterSale/reparationList/components/claimIndemnity'
import inSaleClaimIndemnity from '../afterSale/reparationList/components/inSaleClaimIndemnity'
import porderClaimIndemnity from '../afterSale/reparationList/components/porderClaimIndemnity'
export default {
  data() {
    return {
      user_id: '',
      order_sn: '',
      porder_sn: '',
      after_sale_sn: '',
      reparation_sn: '',//赔款单号
      inspect_sn: '',
      purchase_no: '',
      type: '',//赔款单类型
      list: [],//列表详情
      express_no: '',//物流单号
      service_sn: '',//服务单号

    };
  },
  components: {
    claimIndemnity,
    inSaleClaimIndemnity,
    porderClaimIndemnity
  },
  methods: {
    // 客户详情跳转
    linkUser() {
      let url = this.$router.resolve({
        path: '/user/basicInformation?userID=' + this.user_id,
      });
      window.open(url.href, "_blank");
    },
    // 订单跳转
    linkOrder() {
      let url = this.$router.resolve({
        path: '/orderDetail?order_sn=' + this.order_sn,
      });
      window.open(url.href, "_blank");
    },
    // 配送单跳转
    linkPorder() {
      let url = this.$router.resolve({
        path: '/porderDetail?porder_sn=' + this.porder_sn,
      });
      window.open(url.href, "_blank");
    },
    // 售后单跳转
    linkAfterSaler() {
      this.$api.capitalApi.aftersaleList({ after_sale_sn: this.after_sale_sn }).then((res) => {
        if (res.data.data == false) return this.$message.error('未找到此售后单，请输入正确的售后单')
        let data = res.data.data[0];
        let url
        if (data.is_whole_porder != 1) {
          url = this.$router.resolve({
            path: '/afterSaleOfGoods?after_sale_sn=' + data.after_sale_sn,
          });
        } else {
          url = this.$router.resolve({
            path: '/wholeOrderAfterSale?after_sale_sn=' + data.after_sale_sn,
          });
        }
        window.open(url.href, "_blank");
      });
    },
    // 赔款单跳转
    reparationList() {
      let datas = {
        status: 0,
        page: 1,
        pageSize: 10,
        realnames: '',
        reparation_sn: this.reparation_sn
      }
      let itemData = {}
      this.$api.capitalApi.reparationList(datas).then((res) => {
        if (res.data.data == false) return this.$message.error('未找到此赔款单，请输入正确的赔款单')
        itemData = res.data.data[0];
        // console.log(itemData)
        // 追加的赔款表单
        if (itemData.aftersale_sn_set == false) {
          this.type = itemData.status_name
          this.reparation_sn = itemData.reparation_sn
          if (itemData.order_sn_set != false) {
            itemData.reparation_detail.forEach(items => {
              let data = items.order_detail
              data.amount = items.amount
              this.list.push(data)
            })
            this.$nextTick(() => {
              this.$refs.claimIndemnity.editIndemnity(itemData)
            })
          } else if (itemData.porder_sn_set != false) {
            this.$nextTick(() => {
              this.$refs.porderClaimIndemnity.editIndemnity(itemData)
            })
          } else {
            //售中和抽查赔款用同一个
            this.$nextTick(() => {
              this.$refs.inSaleClaimIndemnity
                .editIndemnity(itemData)
            })
          }

        } else {    // 售后赔款单详情
          let after_sale_item = itemData.aftersale_sn_set[0]
          let url
          if (after_sale_item.is_whole_porder != 1) {
            url = this.$router.resolve({
              path: '/afterSaleOfGoods?after_sale_sn=' + after_sale_item.after_sale_sn + '&reparation_sn=' + itemData.reparation_sn,
            });

          } else {
            url = this.$router.resolve({
              path: '/wholeOrderAfterSale?after_sale_sn=' + after_sale_item.after_sale_sn,
            });
          }
          window.open(url.href, "_blank");
        }


      })
    },
    // 国际物流单号
    linkExpress() {
      let url = this.$router.resolve({
        path: '/porderShipped?express_no=' + this.express_no,
      });
      window.open(url.href, "_blank");

    },
    //检品单列表
    linkInspect() {
      if (this.inspect_sn.indexOf('-') != -1) {
        let url = this.$router.resolve({
          path: '/menu3_follow_inspect_inspect?inspect_sn=' + this.inspect_sn,
        });
        window.open(url.href, "_blank");
      } else {
        let url = this.$router.resolve({
          path: '/menu3_follow_inspect_inspect?purchase_no=' + this.inspect_sn,
        });
        window.open(url.href, "_blank");
      }
    },
    //核查界面跳转
    linkPurchas() {
      let url = this.$router.resolve({
        path: '/inspectDetail?express_no=&purchase_no=' + this.purchase_no,
      });
      window.open(url.href, "_blank");
    },
    //服务单号跳转
    linkService() {
      let url = this.$router.resolve({
        path: '/serviceDetail?service_sn=' + this.service_sn,
      });
      window.open(url.href, "_blank");
    }
  }
}
</script>
<style lang='scss' scoped>
.link {
  display: flex;
  flex-wrap: wrap;

  .item {
    margin-right: 20px;
    margin-bottom: 20px;
    display: flex;
  }
}

/deep/.el-select .el-input__inner {
  height: 32px;
}
</style>